import type { Dispatch, SetStateAction } from 'react';
import type { UIElementProps } from '@adyen/adyen-web/dist/types/components/types';
import type { PlaceOrderMutationFn } from '../../../types';
import { newRelicAvailabilityChecker } from '../../../utils/newrelic';

// Adyen docs - web components - MobilePay
// https://docs.adyen.com/payment-methods/mobilepay/web-component/

export interface CreateMobilePayConfigProps {
  setIsPaymentBtnDisabled: Dispatch<SetStateAction<boolean>>;
  setPaymentInProgress: Dispatch<SetStateAction<boolean>>;
  setPaymentError: Dispatch<SetStateAction<boolean>>;
  placeOrderMutation: PlaceOrderMutationFn;
  onBeforeSubmit: (data: unknown, actions: unknown) => Promise<void>;
}

export const createMobilePayConfig = ({
  setIsPaymentBtnDisabled,
  setPaymentInProgress,
  setPaymentError,
  placeOrderMutation,
  onBeforeSubmit,
}: CreateMobilePayConfigProps): UIElementProps => ({
  showPayButton: false,
  beforeSubmit: async (data: any, _: any, actions: any) => {
    try {
      setIsPaymentBtnDisabled(true);
      setPaymentInProgress(true);

      const result = await placeOrderMutation();

      if (result?.data?.placeOrder.accepted) {
        await onBeforeSubmit(data, actions);
      } else {
        actions.reject();
        setPaymentError(true);
        setIsPaymentBtnDisabled(false);
        setPaymentInProgress(false);
      }
    } catch (error) {
      actions.reject();
      setPaymentError(true);
      setIsPaymentBtnDisabled(false);
      setPaymentInProgress(false);
      console.error('Error during MobilePay payment processing:', error);
      newRelicAvailabilityChecker(() => {
        window.newrelic.noticeError(new Error(`Error during MobilePay payment processing: ${error}`));
      });
    }
  },
});
